import $ from "jquery";

export function handleNavigation() {
    let $body = $('body');
    $body.on('click', '.js-dropdown-button', function () {
        let $element = $(this).parent('.js-dropdown').find('.js-dropdown-links');
        let open = $element.is('.dropdown__links--active');
        $('.js-dropdown-links').removeClass('dropdown__links--active');
        $('.js-main-dropdown-links').removeClass('navigation-dropdown--active');

        if (!open) {
            $element.addClass('dropdown__links--active');
        }

        return false;
    }).on('click', '.js-main-dropdown-button', function () {
        if ('undefined' !== window.USER_CAN_HOVER && window.USER_CAN_HOVER === true) {
            return;
        }

        let $element = $(this).parent('.js-main-dropdown').find('.js-main-dropdown-links');
        let open = $element.is('.navigation-dropdown--active');
        $('.js-dropdown-links').removeClass('dropdown__links--active');
        $('.js-main-dropdown-links').removeClass('navigation-dropdown--active');
        if (!open) {
            $element.addClass('navigation-dropdown--active');
        }
        return false;
    }).on('click', '.js-mobile-navigation', function () {
        $('body').toggleClass('show-navigation');
        return false;
    });

    window.addEventListener('mouseover', function onFirstHover() {
        window.USER_CAN_HOVER = true;
        window.removeEventListener('mouseover', onFirstHover, false);
    }, false);

    handleStickyNav();
}

export function updateStickyNav() {
    let scrollTop = $(window).scrollTop();
    if (scrollTop === 0) {
        $('body').removeClass('body-show-sticky-nav');
        return;
    }

    if (scrollTop > $(".js-header").outerHeight()) {
        $('body').addClass('body-show-sticky-nav');
    }
}

export function handleStickyNav() {
    let $window = $(window);
    let $header = $('.js-header');
    let $navToggle = $('.js-nav-toggle');
    let lastScroll = $window.scrollTop();
    let currentOffset = 0;

    updateStickyNav();

    $window.on("scroll", function () {

        updateStickyNav();

        if ($header.hasClass('header-always-sticky')) {
            $header.css("transform", "");
            return;
        }

        let scroll = $window.scrollTop();
        let diff = lastScroll - scroll;
        let height = $header.outerHeight();

        currentOffset = Math.min(0, Math.max(-height, currentOffset + diff));

        let visibleHeader = Math.min(height, Math.max(0, height + currentOffset));
        $('body').css({'--visible-header': visibleHeader + 'px'});

        if (scroll <= 0) {
            currentOffset = 0;
        }

        lastScroll = scroll;

        if (currentOffset === 0) {
            $header.css("transform", "");
        } else {
            $header.css("transform", "translateY(" + currentOffset + "px)");
        }

    }).on("resize", function () {
        lastScroll = $window.scrollTop();
        $header.css("transform", "");
        $navToggle.css("transform", "");
        currentOffset = 0;
    });
}
